/**************************************************
 * Nombre:       Seccion_Detalles
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Testimonios from "./Componentes/SubComponentes/Testimonios";
import Home_Contactos from "./Componentes/Home_Contactos";
import Detalle_Producto from "./Componentes/Detalle_Producto";
import Detalles_Relacionados from "./Componentes/Detalles_Relacionados";
import {useEffect, useState} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import {useParams} from "react-router";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";

const Seccion_Detalles = () => {
    const parms = useParams()
    const [producto, setProducto] = useState({})

    useEffect(() => {

        irArriba()
        if (parms && parms.id) {

            obtenerDoc('productos', parms.id).then(dox => {
                if (dox.res) {
                    setProducto(dox.data)
                }
            })
        }

    }, [parms])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Detalle_Producto item={producto}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Detalles_Relacionados item={producto}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Testimonios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Contactos/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Detalles